var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTool = function SvgTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12.706 2.556A4.125 4.125 0 0 0 8.57 8.364c.15.332.08.722-.178.98l-5.758 5.758a.893.893 0 1 0 1.262 1.263l5.758-5.759a.875.875 0 0 1 .98-.178 4.125 4.125 0 0 0 5.808-4.135l-2.081 2.082a1.709 1.709 0 0 1-2.392 0l-.006-.006-1.34-1.34a1.708 1.708 0 0 1 0-2.391l.006-.007 2.076-2.075ZM11.276.884a5.875 5.875 0 0 1 3.476.427.875.875 0 0 1 .257 1.416l-3.106 3.106 1.263 1.263 3.106-3.106a.875.875 0 0 1 1.416.258 5.876 5.876 0 0 1-7.198 8l-5.355 5.354a2.643 2.643 0 0 1-3.738-3.737L6.752 8.51A5.875 5.875 0 0 1 11.276.884Z",
    clipRule: "evenodd"
  })));
};
export default SvgTool;